const boxArray = [
  {
    label: "0",
    value: 0
  },
  {
    label: "100万",
    value: 1000000
  },
  {
    label: "500万",
    value: 5000000
  },
  {
    label: "1000万",
    value: 10000000
  },
  {
    label: "2000万",
    value: 20000000
  },
  {
    label: "3000万",
    value: 30000000
  },
  {
    label: "4000万",
    value: 40000000
  },
  {
    label: "5000万",
    value: 50000000
  },
  {
    label: "6000万",
    value: 60000000
  },
  {
    label: "7000万",
    value: 70000000
  },
  {
    label: "8000万",
    value: 80000000
  },
  {
    label: "9000万",
    value: 90000000
  },
  {
    label: "1亿",
    value: 100000000
  },
  {
    label: "2亿",
    value: 200000000
  },
  {
    label: "3亿",
    value: 300000000
  },
  {
    label: "4亿",
    value: 400000000
  },
  {
    label: "5亿",
    value: 500000000
  },
  {
    label: "6亿",
    value: 600000000
  },
  {
    label: "7亿",
    value: 700000000
  },
  {
    label: "8亿",
    value: 800000000
  },
  {
    label: "9亿",
    value: 900000000
  },
  {
    label: "更多",
    value: 50000000000,
  }
];
const yearArray = [
  { label: 2014, value: 2014 },
  { label: 2015, value: 2015 },
  { label: 2016, value: 2016 },
  { label: 2017, value: 2017 },
  { label: 2018, value: 2018 },
  { label: 2019, value: 2019 },
]

export { boxArray, yearArray }